module.exports = __webpack_public_path__ + "js/zalo-inbox.global.79c5d4a8.js";